import { gql } from "@apollo/client";
import { client } from "graphql/client";

export const CREATE_ACCOUNT_PICKUP_STAFF = gql`
    mutation CreateAccountPickupStaff($input: AccountPickupStaffInput!) {
        createAccountPickupStaff(input: $input)
    }
`;

export const UPDATE_ACCOUNT_PICKUP_STAFF = gql`
    mutation UpdateAccountPickupStaff($input: AccountPickupStaffInput!) {
        updateAccountPickupStaff(input: $input)
    }
`;

export interface AccountPickupStaffInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    warehouseId: number;
    role: string;
}

export const createAccountPickupStaff = async (input: AccountPickupStaffInput): Promise<boolean> => {
    const { data } = await client.mutate({
        mutation: CREATE_ACCOUNT_PICKUP_STAFF,
        variables: { input }
    });
    return data.createAccountPickupStaff;
};

export const updateAccountPickupStaff = async (input: AccountPickupStaffInput): Promise<boolean> => {
    const { data } = await client.mutate({
        mutation: UPDATE_ACCOUNT_PICKUP_STAFF,
        variables: { input }
    });
    return data.updateAccountPickupStaff;
};

